var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authenticationType === 'spid')?_c('login-spid'):_c('login')}
var staticRenderFns = []

export { render, staticRenderFns }